import { component as defineComponent } from 'flightjs';

function actions() {
    this.attributes({
        updateDesignUrl: '[data-update-design-url]',
    });

    this.updateDesign = function(data) {
        var xhr = $.ajax({
            method: 'PUT',
            url: this.getDataUrl('updateDesignUrl'),
            data: data,
        });

        xhr.done(
            function(res) {
                this.trigger('dataEntryUpdated', res);
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.trigger('dataEntryActionFailed');
            }.bind(this)
        );

        return xhr;
    };

    // Find an element and fetch a url from it's data attribute
    this.getDataUrl = function(attr) {
        var element = this.select(attr);
        return element.attr(this.attr[attr].replace(/[\[\]]+/g, ''));
    };

    this.restoreEntry = function(e) {
        var xhr = this.updateDesign({ is_deleted: 0 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryRestored');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryRestoredFailed');
            }.bind(this)
        );
    };

    this.deleteEntry = function(e) {
        var xhr = this.updateDesign({ is_deleted: 1 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryDeleted');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryDeletedFailed');
            }.bind(this)
        );
    };

    this.withdraw = function(e) {
        var xhr = this.updateDesign({ is_withdrawn: 1 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryWithdrawn');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryWithdrawnFailed');
            }.bind(this)
        );
    };

    this.unwithdraw = function(e) {
        var xhr = this.updateDesign({ is_withdrawn: 0 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryUnwithdrawn');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryUnwithdrawnFailed');
            }.bind(this)
        );
    };

    this.eliminate = function(e) {
        var xhr = this.updateDesign({ is_eliminated: 1 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryEliminated');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryEliminatedFailed');
            }.bind(this)
        );
    };

    this.uneliminate = function(e) {
        var xhr = this.updateDesign({ is_eliminated: 0 }); // eslint-disable-line camelcase

        xhr.done(
            function(res) {
                this.trigger('dataEntryUneliminated');
            }.bind(this)
        );

        xhr.fail(
            function(res) {
                this.trigger('dataEntryUneliminatedFailed');
            }.bind(this)
        );
    };

    this.after('initialize', function() {
        this.on('uiWithdrawEntryRequested', this.withdraw);
        this.on('uiUnwithdrawEntryRequested', this.unwithdraw);

        this.on('uiEliminateEntryRequested', this.eliminate);
        this.on('uiUneliminateEntryRequested', this.uneliminate);

        this.on('uiDeleteEntryRequested', this.deleteEntry);
        this.on('uiRestoreEntryRequested', this.restoreEntry);
    });
}

export default defineComponent(actions);



// WEBPACK FOOTER //
// ./src/web/js/entry/data/actions.js